import { useMemo } from "react";
import LightBox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import React from "react";
import { getFileExtension, imageExtensions } from "modules/helpers";

const DocumentImageLightbox = ({ images, open, onClose, targetSrc }) => {
  const slides = useMemo(
    () =>
      (images || [])
        .filter((x) => {
          const extension = getFileExtension(x.fileName);
          return imageExtensions.includes(extension);
        })
        .map((x) => {
          const extension = getFileExtension(x.fileName);
          return {
            src: x.url,
            isSvg: extension == "svg",
          };
        }),
    [images]
  );

  const targetIndex = slides.findIndex((s) => s.src == targetSrc && targetSrc);

  return (
    <div
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
    >
      <LightBox
        open={open}
        close={onClose}
        slides={slides}
        index={targetIndex > -1 ? targetIndex : 0}
        styles={{
          container: { backgroundColor: "rgba(0, 0, 0, .7)" },
        }}
        controller={{
          closeOnBackdropClick: true,
        }}
        render={{
          buttonPrev: slides.length <= 1 ? () => null : undefined,
          buttonNext: slides.length <= 1 ? () => null : undefined,
          slideContainer: ({ slide, children }) => (
            <div
              style={{
                height: "100%",
                width: "100%",
                pointerEvents: "none",
                minHeight: slide.isSvg ? "10em" : undefined,
                minWidth: slide.isSvg ? "10em" : undefined,
              }}
            >
              {children}
            </div>
          ),
        }}
        plugins={[Zoom]}
      />
    </div>
  );
};

export default DocumentImageLightbox;
